module.exports = __webpack_public_path__ + "static/media/my_green_company-square.fcc64280.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/my_green_company-square.png
// module id = 1850
// module chunks = 0